import { render } from "./FeedbackModal.vue?vue&type=template&id=0bd36020&scoped=true"
import script from "./FeedbackModal.vue?vue&type=script&lang=js"
export * from "./FeedbackModal.vue?vue&type=script&lang=js"

import "./FeedbackModal.vue?vue&type=style&index=0&id=0bd36020&lang=scss&scoped=true"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd36020"]])

export default __exports__